
import Card from '../ss-card'

import { defineComponent, PropType } from 'vue'
import { MenuStatue } from '../dist/types'

export default defineComponent({
    name: "bc-menu",
    emits: ['close'],
    props: {
        name: {
            type: String,
            default: Math.random().toString(36).substr(2)
        },
        data: {
            type: Object as PropType<MenuStatue>,
            default: () => { return {} }
        }
    },
    components: {
        Card
    },
    data() {
        return {
            custonBody: undefined as 
                { id: string, icon: string | null, name: string }[] | undefined
        }
    },
    methods: {
        closeMsgMenu(id = '') {
            if(id !== '') {
                this.$emit('close', id)
            } else {
                this.$emit('close', null)
            }
        },
    },
    mounted() {
        const body = document.getElementById('msg-menu-body-' + this.name)
        // 如果 body 下面第一个元素是 ul，获取 icon 属性重新构建内容
        if(body && body.children[0] && body.children[0].tagName === 'UL') {
            this.custonBody = []
            for(let i = 0; i < body.children[0].children.length; i++) {
                const li = body.children[0].children[i] as HTMLLIElement
                this.custonBody.push({
                    id: li.id,
                    icon: li.getAttribute('icon'),
                    name: li.innerText
                })
            }
        }
    }
})
